export const CUSTOM_API_HEADERS: CUSTOM_API_HEADERS_INTERFACE = {
  EXTRA_URL_PARAMS: "EXTRA_URL_PARAMS",
};

interface CUSTOM_API_HEADERS_INTERFACE {
  EXTRA_URL_PARAMS: string;
}
